export default "__VITE_ASSET__BRMiN1F0__"